var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.560547 17.25V14.25H15.5605V17.25H0.560547ZM3.56055 11.25H4.61055L10.4605 5.41875L9.3918 4.35L3.56055 10.2V11.25ZM2.06055 12.75V9.5625L10.4605 1.18125C10.598 1.04375 10.7574 0.9375 10.9387 0.8625C11.1199 0.7875 11.3105 0.75 11.5105 0.75C11.7105 0.75 11.9043 0.7875 12.0918 0.8625C12.2793 0.9375 12.448 1.05 12.598 1.2L13.6293 2.25C13.7793 2.3875 13.8887 2.55 13.9574 2.7375C14.0262 2.925 14.0605 3.11875 14.0605 3.31875C14.0605 3.50625 14.0262 3.69063 13.9574 3.87188C13.8887 4.05313 13.7793 4.21875 13.6293 4.36875L5.24805 12.75H2.06055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.24e65845bead7dcaa99516ccf3434c81.svg";
export { ForwardRef as ReactComponent };